import { useState, useEffect } from 'react';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);

      // Set 1-hour timeout
      if (user) {
        const timeout = setTimeout(() => {
          signOut(auth);
        }, 60 * 60 * 1000); // 1 hour

        return () => clearTimeout(timeout);
      }
    });

    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    try {
      setError(null);
      const result = await signInWithEmailAndPassword(auth, email, password);

      // Check email verification
      if (!result.user.emailVerified) {
        await signOut(auth);
        throw new Error('Please verify your email address before proceeding.');
      }

      return result;
    } catch (error) {
      let message = 'Your username or password is incorrect';
      if (error.message.includes('verify')) {
        message = error.message;
      }
      setError(message);
      throw new Error(message);
    }
  };

  const logout = () => signOut(auth);

  return { user, loading, error, login, logout };
};